"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkipAfterProperty = void 0;

var PreconditionFailure_1 = require("../precondition/PreconditionFailure");

var SkipAfterProperty = /*#__PURE__*/function () {
  function SkipAfterProperty(property, getTime, timeLimit, interruptExecution) {
    _classCallCheck(this, SkipAfterProperty);

    this.property = property;
    this.getTime = getTime;
    this.interruptExecution = interruptExecution;
    this.skipAfterTime = this.getTime() + timeLimit;
  }

  _createClass(SkipAfterProperty, [{
    key: "isAsync",
    value: function isAsync() {
      return this.property.isAsync();
    }
  }, {
    key: "generate",
    value: function generate(mrng, runId) {
      return this.property.generate(mrng, runId);
    }
  }, {
    key: "shrink",
    value: function shrink(value) {
      return this.property.shrink(value);
    }
  }, {
    key: "run",
    value: function run(v) {
      if (this.getTime() >= this.skipAfterTime) {
        var preconditionFailure = new PreconditionFailure_1.PreconditionFailure(this.interruptExecution);

        if (this.isAsync()) {
          return Promise.resolve(preconditionFailure);
        } else {
          return preconditionFailure;
        }
      }

      return this.property.run(v);
    }
  }]);

  return SkipAfterProperty;
}();

exports.SkipAfterProperty = SkipAfterProperty;